enum BookMineListRange {
    ALL = "ALL",
    NOT_DONE = "NOT_DONE",
    DONE = "DONE",
    GIVE_UP = "GIVEUP",
    NOT_STARTED = "NOT_STARTED",
    READING = "READING",
EXCLUDE_GIVE_UP = "EXCLUDE_GIVE_UP"
}

export default BookMineListRange